import StatusBadge from "./StatusBadge";

export default function ClientWorkordersTab({ workorders }) {
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
      <h3 className="mb-4 text-sm font-semibold text-slate-900">Werkbonnen</h3>

      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-slate-500">
              <th className="px-2 py-2 font-medium">Werkbonnummer</th>
              <th className="px-2 py-2 font-medium">Titel / omschrijving</th>
              <th className="px-2 py-2 font-medium">Status</th>
              <th className="px-2 py-2 font-medium">Geplande datum</th>
              <th className="px-2 py-2 font-medium">Uitvoerder</th>
              <th className="px-2 py-2 font-medium">Actie</th>
            </tr>
          </thead>
          <tbody>
            {workorders.map((workorder) => (
              <tr key={workorder.id} className="border-b border-slate-100 last:border-b-0">
                <td className="px-2 py-3 font-medium text-slate-800">{workorder.werkbonnummer}</td>
                <td className="px-2 py-3 text-slate-700">{workorder.titel}</td>
                <td className="px-2 py-3"><StatusBadge value={workorder.status} /></td>
                <td className="px-2 py-3 text-slate-700">{workorder.geplandeDatum}</td>
                <td className="px-2 py-3 text-slate-700">{workorder.uitvoerder}</td>
                <td className="px-2 py-3">
                  <button type="button" className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50">
                    Openen
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
